import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/pages/home/home.component';
import { AdmissionComponent } from './components/pages/admission/admission.component';
import { SanteComponent } from './components/pages/sante/sante.component';
import { TechniqueComponent } from './components/pages/technique/technique.component';
import { AdmissionDetailComponent } from './components/pages/admission-detail/admission-detail.component';
import { UniversiteComponent } from './components/pages/universite/universite.component';
import { ContactisnComponent } from './components/pages/contact-isn/contact-isn.component';


const routes: Routes = [
  {
    path:'',component:HomeComponent
  },
  {
    path:'accueil',component:HomeComponent
  },
  {
    path:'admission',component:AdmissionComponent
  },
  {
    path:'sante',component:SanteComponent
  },
  {
    path:'techniqueGestion',component:TechniqueComponent
  },
  {
    path:'admissionDetail',component:AdmissionDetailComponent
  },
  {
    path:'universite',component:UniversiteComponent
  },
  {
    path:'contact-isn',component:ContactisnComponent
  },
  {
    path:'**',component:HomeComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
